import React from "react";
import classes from "../../ARC_Reconciliation/Sales/GST-1_Reconciliation/GSTReconciliation.module.css";


const CreditReversalLedgerTable = ({ data }) => {
    const formatCurrency = (value) => value ? `₹${value.toLocaleString("en-IN")}` : "-";

    return (
        <div
            className="responsive-table"
            style={{ scrollbarWidth: "thin", scrollbarHeight: '25px', maxHeight: '63vh' }}
        >
            <table className={classes.AllInvoiceReconTableCss}>
                <thead>
                    <tr>
                        <th rowSpan={2} style={{ width: '1%' }}>Date</th>
                        <th rowSpan={2} style={{ width: '2%' }}>Reference No</th>
                        <th rowSpan={2} style={{ width: '2%' }}>Return Period
                        </th>
                        <th rowSpan={2} style={{ width: '2%' }}>Description</th>
                        <th colSpan={4} style={{ width: '5%' }}>ITC Claimed (Table 4A(5)) (₹) (All Other ITC)
                        </th>
                        <th colSpan={4} style={{ width: '5%' }}>ITC Reversal (Table 4B(2)) (₹) Eligible to Re-claim
                        </th>
                        <th colSpan={4} style={{ width: '5%' }}>ITC Reclaimed (Table 4D(1)) (₹)
                        </th>
                        <th colSpan={4} style={{ width: '5%' }}>Closing Balance (₹) (Opening Balance +  Reversal (4B(2)) - Reclaimed (4D(1))
                        </th>
                    </tr>
                    <tr>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        {/* <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Total</th> */}
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} style={{ height: '45px' }}>
                                <td>{row.transaction_date || "-"}</td>
                                <td>{row.reference_no || "-"}</td>
                                <td>{row.return_period || "-"}</td>
                                <td>{row.description || "-"}</td>
                                <td>{formatCurrency(row.itc4a5?.igst)}</td>
                                <td>{formatCurrency(row.itc4a5?.cgst)}</td>
                                <td>{formatCurrency(row.itc4a5?.sgst)}</td>
                                <td>{formatCurrency(row.itc4a5?.cess)}</td>
                                {/* <td>{formatCurrency(row.inwardsup_3_1d)}</td> */}

                                {/* itc4a2 - ITC Reversal columns */}
                                <td>{formatCurrency(row.itc4b2?.igst)}</td>
                                <td>{formatCurrency(row.itc4b2?.cess)}</td>
                                <td>{formatCurrency(row.itc4b2?.sgst)}</td>
                                <td>{formatCurrency(row.itc4b2?.cess)}</td>

                                {/* itc4a3 - ITC Reclaimed columns */}
                                <td>{formatCurrency(row.itc4d1?.igst)}</td>
                                <td>{formatCurrency(row.itc4d1?.cgst)}</td>
                                <td>{formatCurrency(row.itc4d1?.sgst)}</td>
                                <td>{formatCurrency(row.itc4d1?.cess)}</td>


                                {/* Closing Balance columns - would need calculation logic */}
                                <td>{formatCurrency(row.clsbal?.igst)}</td>
                                <td>{formatCurrency(row.clsbal?.gst)}</td>
                                <td>{formatCurrency(row.clsbal?.sgst)}</td>
                                <td>{formatCurrency(row.clsbal?.cess)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={50} style={{ textAlign: "center", fontWeight: "bold" }}>Loading… Please wait</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CreditReversalLedgerTable;
